// src/components/Admin/AdminRouter.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from '../../pages/Admin/AdminDashboard';
import ContentManagement from '../../pages/Admin/Content/ContentManagement';
import SeriesManagement from '../../pages/Admin/Content/SeriesManagement';
import LiveStreamManagement from '../../pages/Admin/LiveStreams/LiveStreamManagement';
import GoLivePage from '../../pages/Admin/LiveStreams/GoLivePage';
import AnalyticsDashboard from '../../pages/Admin/Analytics/AnalyticsDashboard';
import AdminSettings from '../../pages/Admin/Settings/AdminSettings';
import UserManagement from '../../pages/Admin/Users/UserManagement';
import TeamPositionManagement from '../../pages/Admin/Positions/TeamPositionManagement';
import UserDetail from '../../pages/Admin/Users/UserDetail';
import ModerationQueue from '../../pages/Admin/Moderation/ModerationQueue';
import CastingManagement from '../../pages/Admin/Casting/CastingManagement';
import MemberManagement from '../../pages/Admin/Members/MemberManagement';
import ProductionManagement from '../../pages/Admin/Productions/ProductionManagement';
import EmailCampaigns from '../../pages/Admin/Communications/EmailCampaigns';
import PushNotifications from '../../pages/Admin/Communications/PushNotifications';

const SystemSettingsPlaceholder = () => (
  <div className="p-6">
    <h1 className="text-2xl font-bold text-gray-900 mb-4">System Settings</h1>
    <div className="bg-white rounded-lg shadow p-6">
      <p className="text-gray-600">System settings coming soon...</p>
    </div>
  </div>
);

const AdminRouter: React.FC = () => {
  return (
    <Routes>
      {/* Dashboard - Default route mounted at /admin */}
      <Route index element={<AdminDashboard />} />

      {/* User Management */}
      <Route path="users" element={<UserManagement />} />
      <Route path="users/admins" element={<UserManagement />} />
      <Route path="users/pending" element={<UserManagement />} />
      {/* The jobs an admin or staff member can hold. Under users because that is where
          they are assigned, and admin-only: staff may read the list for their dropdown
          but which jobs exist on the team is not their decision.
          Above users/:id deliberately - React Router ranks a static segment over a
          dynamic one either way, but nobody reading this should have to know that. */}
      <Route path="users/positions" element={<TeamPositionManagement />} />
      <Route path="users/:id" element={<UserDetail />} />

      {/* Content Management */}
      {/* Casting: creating calls and reviewing applications. These endpoints existed
          with no screen, which is why production has no casting calls at all. */}
      <Route path="casting" element={<CastingManagement />} />
      {/* Membership is by application: nobody is listed publicly until approved here. */}
      <Route path="members" element={<MemberManagement />} />
      {/* Productions carry the credits shown under a film. The endpoints existed with
          no screen, so credits had to be inserted by hand. */}
      <Route path="productions" element={<ProductionManagement />} />
      <Route path="content" element={<ContentManagement />} />
      <Route path="content/cinema" element={<ContentManagement />} />
      <Route path="content/contents" element={<ContentManagement />} />
      <Route path="content/podcasts" element={<ContentManagement />} />
      <Route path="content/animations" element={<ContentManagement />} />
      <Route path="content/sneak-peeks" element={<ContentManagement />} />
      <Route path="content/live-videos" element={<ContentManagement />} />
      
      {/* Series Management */}
      <Route path="series" element={<SeriesManagement />} />
      <Route path="series/cinema" element={<SeriesManagement />} />
      <Route path="series/contents" element={<SeriesManagement />} />
      <Route path="series/podcasts" element={<SeriesManagement />} />
      <Route path="series/animations" element={<SeriesManagement />} />

      {/* Live Streaming (Admin Go Live) */}
      <Route path="live-streams" element={<LiveStreamManagement />} />
      <Route path="live-streams/go-live/:streamId" element={<GoLivePage />} />

      {/* Moderation */}
      <Route path="moderation" element={<ModerationQueue />} />

      {/* Analytics */}
      <Route path="analytics" element={<AnalyticsDashboard />} />
      <Route path="analytics/users" element={<AnalyticsDashboard />} />
      <Route path="analytics/content" element={<AnalyticsDashboard />} />
      <Route path="analytics/engagement" element={<AnalyticsDashboard />} />

      {/* Communications */}
      <Route path="communications/email" element={<EmailCampaigns />} />
      <Route path="communications/notifications" element={<PushNotifications />} />

      {/* System */}
      <Route path="system/settings" element={<AdminSettings />} />
      <Route path="system/backup" element={<SystemSettingsPlaceholder />} />
      <Route path="system/logs" element={<SystemSettingsPlaceholder />} />

      {/* Catch all - redirect to admin root */}
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};

export default AdminRouter;